export default __webpack_public_path__ + "static/media/tut6.501c9598.png";